import React from 'react';
import './Screenshots.css';

const HowItWorks: React.FC = () => {
  const vibes = [
    { level: 'INSANE', emoji: '🔥🔥🔥', desc: 'This place is absolutely packed. Grab a Lyft NOW.', color: '#FF2DAA' },
    { level: 'LIT', emoji: '🔥🔥', desc: 'Strong crowd, great energy. Worth pulling up.', color: '#A020F0' },
    { level: 'GOOD', emoji: '🔥', desc: 'Decent vibe. Not dead, not popping. Solid choice.', color: '#00C2FF' },
    { level: 'CHILL', emoji: '😐', desc: 'Low-key tonight. Either early or just not it.', color: '#5577aa' },
    { level: 'DEAD', emoji: '💀', desc: 'Save your night. Nobody\'s here.', color: '#444' },
  ];

  const steps = [
    {
      num: '01',
      title: 'Open LITSCAN',
      desc: 'Pull up the app before you head out. See every venue in your city on one live screen.',
      icon: '📱'
    },
    {
      num: '02',
      title: 'Scan the Vibe',
      desc: 'Each bar and club shows a real-time vibe score — updated by people already there.',
      icon: '⚡'
    },
    {
      num: '03',
      title: 'Rate Where You Are',
      desc: 'Once you\'re out, tap your vibe in 5 seconds. You power the data for everyone else.',
      icon: '🗳️'
    },
    {
      num: '04',
      title: 'Find the Energy',
      desc: 'Navigate to what\'s lit, skip what\'s dead, and never waste a night again.',
      icon: '🗺️'
    },
  ];

  return (
    <section id="how-it-works" className="screenshots section">
      <div className="container">
        <div className="screenshots-header">
          <div className="section-badge">🎯 Simple by Design</div>
          <h2>How LITSCAN Works</h2>
          <p>Five vibe levels. One tap. Instant nightlife intelligence.</p>
        </div>

        <div className="vibe-scale">
          {vibes.map((v, i) => (
            <div key={i} className="vibe-item" style={{ '--vibe-color': v.color } as React.CSSProperties}>
              <div className="vibe-emoji">{v.emoji}</div>
              <div className="vibe-level" style={{ color: v.color }}>{v.level}</div>
              <div className="vibe-desc">{v.desc}</div>
            </div>
          ))}
        </div>

        <div className="how-steps">
          {steps.map((s, i) => (
            <div key={i} className="how-step">
              <div className="step-icon">{s.icon}</div>
              <div className="step-num">{s.num}</div>
              <h3 className="step-title">{s.title}</h3>
              <p className="step-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
